import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Wrapper = styled.div`
  position: relative;
`;

export const Content = styled.div`
  filter: blur(4px);
  pointer-events: none;
  user-select: none;
`;

export const LockOverlay = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  padding: 12px;

  background-color: ${colors.surfaceContainerLow}d9;
  border-radius: ${radius.md};

  span {
    font-size: 12.5px;
    font-weight: 700;
    color: ${colors.onSurface};
    max-width: 240px;
  }
`;
